export default __webpack_public_path__ + "static/media/imgDarkEn5.f44531c8.png";